import { styled } from 'solid-styled-components';
import { COLORS, TYPOGRAPHY } from '../../../constants/design-tokens';

const Shell = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 0;
  color: ${COLORS.phosphor.green};
  font-family: ${TYPOGRAPHY.fontFamily.mono.join(', ')};
  font-size: ${TYPOGRAPHY.fontSize.sm};
  letter-spacing: 0.04em;
  padding: 0;
  margin: 0;
  line-height: 1;
  cursor: pointer;
  text-shadow: 0 0 10px ${COLORS.phosphor.bloom};

  &:hover:not(:disabled),
  &:focus-visible:not(:disabled) {
    color: ${COLORS.phosphor.green};
    text-shadow: 0 0 16px ${COLORS.phosphor.green};
    outline: none;
  }

  &:hover:not(:disabled) [data-kind='idle'],
  &:focus-visible:not(:disabled) [data-kind='idle'] {
    opacity: 0;
  }

  &:hover:not(:disabled) [data-kind='hot'],
  &:focus-visible:not(:disabled) [data-kind='hot'] {
    opacity: 1;
  }

  &:disabled {
    cursor: default;
    opacity: 0.55;
    text-shadow: none;
  }

  @media (prefers-reduced-motion: reduce) {
    text-shadow: none;

    &:hover:not(:disabled),
    &:focus-visible:not(:disabled) {
      text-shadow: none;
    }
  }
`;

const Sizer = styled.span`
  visibility: hidden;
  white-space: pre;
  pointer-events: none;
  color: inherit;
`;

const Layer = styled.span`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: pre;
  pointer-events: none;
  color: inherit;

  &[data-kind='hot'] {
    opacity: 0;
  }
`;

/**
 * Compact [x] that becomes [ x ] on hover without shifting neighbors.
 *
 * @param {Object} props
 * @param {string} props.mark - Inner glyph (x, -, +)
 * @param {Function} props.onClick
 * @param {boolean} props.disabled
 * @param {string} props.ariaLabel
 * @param {string} props.title
 * @param {string} props.data-testid
 */
const GlyphControl = (props) => {
  const compact = () => `[${props.mark}]`;
  const expanded = () => `[ ${props.mark} ]`;

  return (
    <Shell
      type="button"
      onClick={props.onClick}
      disabled={props.disabled}
      aria-label={props.ariaLabel}
      title={props.title}
      data-testid={props['data-testid']}
    >
      <Sizer aria-hidden="true">{expanded()}</Sizer>
      <Layer data-kind="idle">{compact()}</Layer>
      <Layer data-kind="hot">{expanded()}</Layer>
    </Shell>
  );
};

export default GlyphControl;
